<script lang="ts">
	import { Responsive } from "responsive"

	interface Props {
		onSubscribe: () => void
	}

	let { onSubscribe }: Props = $props()
</script>

<div class="subscribe-card" class:isMobile={Responsive.isMobile}>
	<div class="sub-info">
		<h2>Go Beyond Free Themes</h2>
		<p>
			A LuxStudio subscription gives you access to premium collections and upcoming seasonal drops.
		</p>
	</div>
	<button class="outline-button square-button subscribe-button" onclick={onSubscribe}
		>Upgrade Now</button
	>
</div>

<style>
	.subscribe-card {
		display: flex;
		flex-direction: row;
		border-radius: var(--br);
		background-color: var(--color-bg-dark);
		padding: 1rem;
		width: 100%;
		margin-bottom: 1rem;
		justify-content: space-between;
	}

	.subscribe-card.isMobile {
		flex-direction: column;
		align-items: center;
		text-align: center;
	}

	.subscribe-button {
		font-size: var(--h1);
		padding: 0.5rem 1rem;
	}

	.isMobile .subscribe-button {
		margin-top: 1rem;
		width: 100%;
	}

	.sub-info {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	h2 {
		margin: 0;
		font-size: var(--h1);
	}

	h2 :global(svg) {
		margin: 0.5rem;
		max-height: 3.5rem;
		width: fit-content;
	}

	p {
		line-height: 1.4;
		color: var(--color-text);
		margin-bottom: 0;
	}
</style>
